import { render, staticRenderFns } from "./PendingAlert.vue?vue&type=template&id=6b9d85fe&scoped=true&"
import script from "./PendingAlert.vue?vue&type=script&lang=js&"
export * from "./PendingAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9d85fe",
  null
  
)

export default component.exports